<template>
<div>
    <base-header v-once pageName="영업활동계획서" :prevBtnShow="true"></base-header>
    <section id="wrap">
        <h3 class="bsnsAcpln-tit">{{planYr}}년 {{planMn}}월 영업활동계획</h3>
        <div class="bsnsAcpln-write">
            <div>
                <h6>개인 실적 목표</h6>
                <span><em>{{amtSum | numFormat}}<template v-if="stat === 'C'">({{orcpAmtSum | numFormat}})</template></em>만원</span>
                <ul>
                    <li v-for="amt in amtList" v-bind:key="amt.cateCd">
                        <strong>{{amt.cateNm}}</strong>
                        <p>
                            <input type="tel" v-model="amt.goalAmt" @input="onAmtInput(amt)"><em>만원</em><template v-if="stat === 'C'"> /
                            <input type="text" v-bind:value="amt.orcpGoalAmt | numFormat" readonly><em>만원</em> </template>
                        </p>
                    </li>
                </ul>
            </div>
            <div>
                <h6>활동 목표</h6>
                <ul class="flex">
                    <li v-for="act in activityItems" v-bind:key="act.cateCd">
                        <strong>{{act.cateNm}}</strong>
                        <p><input type="number" v-bind:disabled="disableChk()" v-model="act.goalCscnt"><em>건</em></p>
                    </li>
                </ul>
            </div>
            <div v-if="counselItems.length">
                <h6>상담 목표</h6>
                <ul class="flex">
                    <li v-for="act in counselItems" v-bind:key="act.cateCd">
                        <strong>{{act.cateNm}}</strong>
                        <p><input type="number" v-bind:disabled="disableChk()" v-model="act.goalCscnt"><em>건</em></p>
                    </li>
                </ul>
            </div>
        </div>
        <dl class="bsnsAcpln-write" v-if="periodRows.length">
            <dt>
                구간 마감
                <p>* 구간 실적은 자동비율로 노출됩니다.</p>
            </dt>
            <dd>
                <p>단위(만원)</p>
                <table>
                    <thead>
                        <tr>
                            <th>마감</th>
                            <th>목표</th>
                            <th v-for="amt in amtList" v-bind:key="'th-'+amt.cateCd">{{amt.cateNm}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in periodRows" v-bind:key="row.label">
                            <td>{{row.label}}</td>
                            <td>{{Math.floor(row.ratio*100)+'%'}}</td>
                            <td v-for="amt in amtList" v-bind:key="row.label+'-'+amt.cateCd">{{ratioAmt(amt, row.ratio) | numFormat}}</td>
                        </tr>
                    </tbody>
                </table>
            </dd>
        </dl>
        <dl class="bsnsAcpln-write">
            <dt>기타 보고사항</dt>
            <dd class="memo">
                <textarea name="" id="" placeholder="기타 내용을 입력해주세요." v-model="memo"></textarea>
                <span><em>{{txtSize}}</em>/1000Byte</span>
            </dd>
        </dl>
    </section>
    <div class="btnWrap">
        <button type="button" class="black" @click="onCancel">취소</button>
        <button type="button" class="red" @click="saveBsnPlan">{{saveTxt}}</button>
    </div>
</div>
</template>

<script>
// 영업활동계획(신규) 등록/수정 — 새 테이블 전용 화면.
// 카테고리(실적목표/활동목표)는 TBL_COMN_CD(BPA/BPG, USE_YN='Y')에서 그대로 받아 동적으로 렌더링하므로,
// 나중에 카테고리가 추가/삭제되어도 이 화면 코드는 수정할 필요가 없다.
// 기존 /mypage/bsnPlnReg (BsnPlnReg.vue) 는 전혀 건드리지 않는다.

// 활동목표(BPG) 중 "상담 목표" 섹션에 들어갈 카테고리 코드 — 기존상담(BPG04), 신규상담(BPG05).
// DB는 ACT_DTL 하나로 합쳐져 있지만, 화면은 기획서대로 "활동 목표"/"상담 목표" 2섹션으로 나눠 보여준다.
var COUNSEL_CATE_CDS = ['BPG04', 'BPG05'];

export default {
  name: "BsnPlan2Reg",

  data() {
    return {
      sqno: this.$route.query.sqno,
      planYr: this.$route.query.planYr,
      planMn: this.$route.query.planMn,
      stat: '',
      txtSize: 0,
      saveTxt: '등록',

      amtList: [],
      actList: [],
      memo: '',
      periodRows: []
    };
  },

  computed: {
    amtSum: function() {
      return this.amtList.reduce(function(sum, amt) {
        var v = (amt.goalAmt || '').toString().replace(/,/g, '');
        return sum + Number(v || 0);
      }, 0);
    },

    // 최초 확정 당시 값(ORCP)의 합계 — stat === 'C' 로 재수정할 때 "현재합계(원래합계)" 형태로 보여준다.
    orcpAmtSum: function() {
      return this.amtList.reduce(function(sum, amt) {
        var v = (amt.orcpGoalAmt || '').toString().replace(/,/g, '');
        return sum + Number(v || 0);
      }, 0);
    },

    // 활동목표(BPG)는 DB상 한 테이블(ACT_DTL)이지만, 화면은 기획서대로 "활동 목표"/"상담 목표"
    // 두 섹션으로 나눠 보여준다. 어떤 카테고리가 "상담"인지는 카테고리 코드로 구분한다 —
    // 나중에 상담 관련 카테고리가 추가/변경되면 COUNSEL_CATE_CDS 도 같이 확인해줘야 한다.
    counselItems: function() {
      return this.actList.filter(function(act) { return COUNSEL_CATE_CDS.indexOf(act.cateCd) !== -1; });
    },
    activityItems: function() {
      return this.actList.filter(function(act) { return COUNSEL_CATE_CDS.indexOf(act.cateCd) === -1; });
    }
  },

  watch: {
    memo(newVal, oldVal) {
      var byte = 0;

      for (var i = 0; i < newVal.length; ++i) {
        (newVal.charCodeAt(i) > 127) ? byte += 2 : byte++;
      }

      if (byte > 1000)
        this.memo = oldVal;
      else
        this.txtSize = byte;
    }
  },

  methods: {
    // 기존 BsnPlnReg.vue 의 disableChk() 와 동일 —
    // 신규 작성이거나 "요청받은 건(stat='R')"을 처음 채우는 경우에만 건수 입력이 가능하고,
    // 한 번 확정(stat='C')된 뒤에는 금액만 수정할 수 있고 활동/상담 건수는 잠긴다.
    disableChk: function() {
      if (!this.sqno || this.stat === 'R') {
        return false;
      }
      return true;
    },

    ratioAmt: function(amt, ratio) {
      var v = Number((amt.goalAmt || '0').toString().replace(/,/g, '') || 0);
      return Math.floor(v * ratio);
    },

    onAmtInput: function(amt) {
      var result = (amt.goalAmt || '').toString().replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => amt.goalAmt = result);
    },

    onCancel: function() {
      if (confirm('수정 중인 영업활동계획을 취소 하시겠습니까?')) {
        this.$router.push('/bsnplan2/list');
      }
    },

    saveBsnPlan: function() {
      for (var i = 0; i < this.amtList.length; i++) {
        var amt = this.amtList[i];
        if (!amt.goalAmt || !(amt.goalAmt + '').trim()) {
          alert(amt.cateNm + " 실적을 입력해주세요.");
          return false;
        }
      }
      for (var j = 0; j < this.actList.length; j++) {
        var act = this.actList[j];
        if (!act.goalCscnt || !(act.goalCscnt + '').trim()) {
          alert(act.cateNm + " 목표를 입력해주세요.");
          return false;
        }
      }

      if (confirm("영업활동계획을 " + this.saveTxt + "하시겠습니까?")) {
        var that = this;

        var amtItems = this.amtList.map(function(amt) {
          return {
            cateCd: amt.cateCd,
            goalAmt: (amt.goalAmt + '').replace(/,/g, '')
          };
        });
        var actItems = this.actList.map(function(act) {
          return {
            cateCd: act.cateCd,
            goalCscnt: act.goalCscnt
          };
        });

        var parameters = {
          sqno: this.sqno,
          stat: this.stat,
          planYr: this.planYr,
          planMn: this.planMn,
          memo: this.memo,
          amtItemsJson: JSON.stringify(amtItems),
          actItemsJson: JSON.stringify(actItems)
        };

        this.$api.bsnPlan2
          .save(parameters)
          .then(function(data) {
            if (data) {
              alert(that.saveTxt + "되었습니다.");
              that.$router.push('/bsnplan2/list');
            } else {
              alert(that.saveTxt + "에 실패하였습니다.");
            }
          })
          .catch(function(error) {
            alert(error.rtMsg);
          });
      }
    }
  },

  filters: {
    numFormat: function(num) {
      if (num == null || num == 0) return 0;

      var n = num + '';
      var reg = /(^[+-]?\d+)(\d{3})/;

      while (reg.test(n))
        n = n.replace(reg, '$1' + ',' + '$2');

      return n;
    }
  },

  created: function() {
    if (this.sqno) {
      this.saveTxt = '수정';
    }

    var that = this;
    var parameters = {
      sqno: this.sqno,
      planYr: this.planYr,
      planMn: this.planMn
    };
    this.$api.bsnPlan2
      .form(parameters)
      .then(function(data) {
        if (data) {
          that.stat = data.stat || '';
          that.memo = data.memo || '';
          that.amtList = (data.amtList || []).map(function(amt) {
            if (amt.goalAmt) {
              amt.goalAmt = Number(amt.goalAmt).toLocaleString();
            }
            return amt;
          });
          that.actList = data.actList || [];
        }
      })
      .catch(function(error) {
        alert(error.rtMsg);
      });

    // 구간 마감 자동비율표 — 기존 화면과 동일하게 TBL_COMN_CD(PREN_CD='CSC') 기반 비율을
    // 그대로 재사용한다. sqno 없이 호출하면 TBL_SLOP_ACTV_PLAN 은 전혀 조회하지 않는,
    // 순수 비율 조회 전용 분기라 안전하게 재사용 가능하다.
    this.$api.mypage
      .bsnPlnInfo({})
      .then(function(data) {
        if (data && data.period && data.period.length >= 5) {
          var labels = ['1영업일', '1구간', '2구간', '3구간', '월마감'];
          that.periodRows = data.period.slice(0, 5).map(function(p, i) {
            return { label: labels[i], ratio: Number(p.cdVl1) };
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>
